export default __webpack_public_path__ + "static/media/auth-password.8119f31f.png";